import React from 'react'
import { EmrReportMetadataField } from '@awell/ui-kit/compositions/ActivityFeed'

interface EmrMetadataTabContentProps {
  metadata: Array<EmrReportMetadataField> | undefined
}

export const EmrMetadataTabContent = ({ metadata }: EmrMetadataTabContentProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-2">
      {metadata?.map(_metadata => {
        const { label, value } = _metadata
        return (
          <div>
            <div className="text-sm text-slate-600">{label}</div>
            {value ? (
              <div className="text-base font-medium text-slate-800">{value}</div>
            ) : (
              <div className="text-sm text-slate-600">Value was not provided</div>
            )}
          </div>
        )
      })}
    </div>
  )
}
